import { ContactAndTravelerSelectors } from "@apac/checkout";
import { PassengerType } from "@b2bportal/core-types";
import { getPassengerType } from "@b2bportal/core-utilities";
import type { Traveler } from "@b2bportal/traveler-api";
import { useCheckoutStateSelector } from "@checkout/context";
import { FlightSelectors } from "@checkout/states";

interface UseInfantInfoReturn {
  isInfant: boolean;
  seatType: "OwnSeat" | "OnLap" | undefined;
}

export const useInfantInfo = ({
  passenger,
}: {
  passenger: Traveler;
}): UseInfantInfoReturn => {
  // The name of the function is wrong; this function just looks at the passenger's DOB
  // and returns whether they are considered an infant.
  // Also, this is not a selector but a utility function exported along with selectors.
  const departureDate = useCheckoutStateSelector(
    FlightSelectors.getFlightSearchDepartureDate
  );

  const passengerType = getPassengerType({
    dateOfBirth: passenger.dateOfBirth,
    tripDate: departureDate ?? undefined,
  });

  const isInfant =
    passengerType === PassengerType.InfantInLap ||
    passengerType === PassengerType.InfantInSeat;

  const seatedPassengerIds = useCheckoutStateSelector(
    ContactAndTravelerSelectors.getSelectedTravelerIds
  );
  const lapInfantIds = useCheckoutStateSelector(
    ContactAndTravelerSelectors.getSelectedInfantTravelerIds
  );

  if (isInfant) {
    if (lapInfantIds.includes(passenger.id)) {
      return { isInfant: true, seatType: "OnLap" };
    } else if (seatedPassengerIds.includes(passenger.id)) {
      return { isInfant: true, seatType: "OwnSeat" };
    } else {
      return { isInfant: true, seatType: undefined };
    }
  }
  return { isInfant: false, seatType: undefined };
};
